import { apiVariable } from "./apiVariable";

export interface Company {
  id: string;
  name: string;
}

export const getCompanies = async (
  token: string | null | undefined
): Promise<Company[]> => {
  const response = await fetch(`${apiVariable}/displayOwnerCompanies`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) throw new Error("Failed to fetch companies");
  return response.json();
};
